module.exports = __webpack_public_path__ + "img/ag_building.8e0c9411.jpg";